// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_option from "bs-platform/lib/es6/js_option.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";

function mapStringToIconType(icon) {
  var match = icon.toLowerCase();
  switch (match) {
    case "back" :
        return /* Back */0;
    case "backCircle" :
        return /* BackCircle */26;
    case "bin" :
        return /* Bin */2;
    case "calendar" :
        return /* Calendar */14;
    case "check" :
        return /* Check */3;
    case "checkCircle" :
        return /* CheckCircle */29;
    case "close" :
        return /* Close */4;
    case "closeCircle" :
        return /* CloseCircle */28;
    case "criminalcircle" :
        return /* CriminalCircle */42;
    case "doctorcircle" :
        return /* DoctorCircle */39;
    case "dollarsign" :
        return /* DollarSign */36;
    case "down" :
        return /* Down */7;
    case "downCircle" :
        return /* DownCircle */32;
    case "drugcircle" :
        return /* DrugCircle */40;
    case "errorCircle" :
        return /* ErrorCircle */34;
    case "favorite" :
        return /* Favorite */20;
    case "friendAdd" :
        return /* FriendAdd */17;
    case "gearcircle" :
        return /* GearCircle */41;
    case "groupAdd" :
        return /* GroupAdd */15;
    case "groupFriend" :
        return /* GroupFriend */16;
    case "healthycircle" :
        return /* HealthyCircle */45;
    case "help" :
        return /* Help */23;
    case "home" :
        return /* Home */21;
    case "hospcircle" :
        return /* HospCircle */43;
    case "info" :
        return /* Info */22;
    case "lock" :
        return /* Lock */24;
    case "logoshort" :
        return /* LogoShort */38;
    case "map" :
        return /* Map */25;
    case "menu" :
        return /* Menu */13;
    case "minus" :
        return /* Minus */6;
    case "minusCircle" :
        return /* MinusCircle */31;
    case "more" :
        return /* More */12;
    case "next" :
        return /* Next */1;
    case "nextCircle" :
        return /* NextCircle */27;
    case "notifications" :
        return /* Notifications */9;
    case "pencil" :
        return /* Pencil */11;
    case "person" :
        return /* Person */37;
    case "plus" :
        return /* Plus */5;
    case "plusCircle" :
        return /* PlusCircle */30;
    case "relaspecircle" :
        return /* RelaspeCircle */44;
    case "search" :
        return /* Search */10;
    case "twobags" :
        return /* TwoBags */35;
    case "up" :
        return /* Up */8;
    case "upCircle" :
        return /* UpCircle */33;
    case "userProfile" :
        return /* UserProfile */19;
    case "userProfileRoundBg" :
        return /* UserProfileRoundBg */18;
    default:
      return ;
  }
}

function mapIcon(icon, fill) {
  switch (icon) {
    case /* Back */0 :
        return {
                iconType: /* Back */0,
                className: "back",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
                        }), React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }))
              };
    case /* Next */1 :
        return {
                iconType: /* Next */1,
                className: "next",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
                        }), React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }))
              };
    case /* Bin */2 :
        return {
                iconType: /* Bin */2,
                className: "bin",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                        }), React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }))
              };
    case /* Check */3 :
        return {
                iconType: /* Check */3,
                className: "check",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                        }))
              };
    case /* Close */4 :
        return {
                iconType: /* Close */4,
                className: "close",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                        }), React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }))
              };
    case /* Plus */5 :
        return {
                iconType: /* Plus */5,
                className: "plus",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0V0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                        }))
              };
    case /* Minus */6 :
        return {
                iconType: /* Minus */6,
                className: "minus",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0V0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M19 13H5v-2h14v2z"
                        }))
              };
    case /* Down */7 :
        return {
                iconType: /* Down */7,
                className: "down",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0V0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
                        }))
              };
    case /* Up */8 :
        return {
                iconType: /* Up */8,
                className: "up",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0V0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
                        }))
              };
    case /* Notifications */9 :
        return {
                iconType: /* Notifications */9,
                className: "notifications",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0V0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
                        }))
              };
    case /* Search */10 :
        return {
                iconType: /* Search */10,
                className: "search",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0V0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                        }))
              };
    case /* Pencil */11 :
        return {
                iconType: /* Pencil */11,
                className: "pencil",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                        }))
              };
    case /* More */12 :
        return {
                iconType: /* More */12,
                className: "more",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                        }))
              };
    case /* Menu */13 :
        return {
                iconType: /* Menu */13,
                className: "menu",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
                        }))
              };
    case /* Calendar */14 :
        return {
                iconType: /* Calendar */14,
                className: "calendar",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z"
                        }))
              };
    case /* GroupAdd */15 :
        return {
                iconType: /* GroupAdd */15,
                className: "groupAdd",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"
                        }))
              };
    case /* GroupFriend */16 :
        return {
                iconType: /* GroupFriend */16,
                className: "groupFriend",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0V0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04 1.14.83 1.93 1.94 1.93 3.41V18c0 .35-.07.69-.18 1H22c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5z"
                        }))
              };
    case /* FriendAdd */17 :
        return {
                iconType: /* FriendAdd */17,
                className: "friendAdd",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0V0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V8c0-.55-.45-1-1-1s-1 .45-1 1v2H2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1H6zm9 4c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
                        }))
              };
    case /* UserProfileRoundBg */18 :
        return {
                iconType: /* UserProfileRoundBg */18,
                className: "userProfileroundbg",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
                        }))
              };
    case /* UserProfile */19 :
        return {
                iconType: /* UserProfile */19,
                className: "userProfile",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M12,12.9c-2,0-6,1.5-6,4.3v1.9h12v-1.9C18,14.4,14,12.9,12,12.9z"
                        }), React.createElement("circle", {
                          cx: "12",
                          cy: "8",
                          r: "3"
                        }))
              };
    case /* Favorite */20 :
        return {
                iconType: /* Favorite */20,
                className: "favorite",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                        }))
              };
    case /* Home */21 :
        return {
                iconType: /* Home */21,
                className: "home",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
                        }))
              };
    case /* Info */22 :
        return {
                iconType: /* Info */22,
                className: "info",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                        }))
              };
    case /* Help */23 :
        return {
                iconType: /* Help */23,
                className: "help",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
                        }))
              };
    case /* Lock */24 :
        return {
                iconType: /* Lock */24,
                className: "lock",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                        }))
              };
    case /* Map */25 :
        return {
                iconType: /* Map */25,
                className: "map",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                        }))
              };
    case /* BackCircle */26 :
        return {
                iconType: /* BackCircle */26,
                className: "backCircle",
                content: React.createElement("svg", {
                      id: "Layer_1",
                      version: "1.1",
                      viewBox: "0 0 24 24",
                      x: "0px",
                      xmlns: "http://www.w3.org/2000/svg",
                      y: "0px"
                    }, React.createElement("g", undefined, React.createElement("path", {
                              d: "M12,0.5C5.5,0.5,0.3,5.7,0.3,12.2S5.5,23.9,12,23.9s11.7-5.2,11.7-11.7S18.5,0.5,12,0.5z M12,21.9c-5.3,0-9.7-4.4-9.7-9.7c0-5.3,4.4-9.7,9.7-9.7c5.3,0,9.7,4.4,9.7,9.7C21.7,17.5,17.3,21.9,12,21.9z"
                            }), React.createElement("polygon", {
                              points: "15.2,4.3 7.4,12.2 15.2,20 16.6,18.6 10.2,12.2 16.6,5.7 \t"
                            })))
              };
    case /* NextCircle */27 :
        return {
                iconType: /* NextCircle */27,
                className: "NextCircle",
                content: React.createElement("svg", {
                      id: "Layer_1",
                      version: "1.1",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M12,0.5C5.5,0.5,0.3,5.7,0.3,12.2S5.5,23.9,12,23.9s11.7-5.2,11.7-11.7S18.5,0.5,12,0.5z M12,21.9c-5.3,0-9.7-4.4-9.7-9.7c0-5.3,4.4-9.7,9.7-9.7c5.3,0,9.7,4.4,9.7,9.7C21.7,17.5,17.3,21.9,12,21.9z"
                        }), React.createElement("polygon", {
                          points: "9.8,4.3 17.6,12.2 9.8,20 8.4,18.6 14.8,12.2 8.4,5.7 "
                        }))
              };
    case /* CloseCircle */28 :
        return {
                iconType: /* CloseCircle */28,
                className: "closeCircle",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                        }))
              };
    case /* CheckCircle */29 :
        return {
                iconType: /* CheckCircle */29,
                className: "checkCircle",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0V0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
                        }))
              };
    case /* PlusCircle */30 :
        return {
                iconType: /* PlusCircle */30,
                className: "plusCircle",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                        }))
              };
    case /* MinusCircle */31 :
        return {
                iconType: /* MinusCircle */31,
                className: "minusCircle",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M0 0h24v24H0z",
                          fill: "none"
                        }), React.createElement("path", {
                          d: "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                        }))
              };
    case /* DownCircle */32 :
        return {
                iconType: /* DownCircle */32,
                className: "downCircle",
                content: React.createElement("svg", {
                      id: "Layer_1",
                      version: "1.1",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M12,0.3C5.6,0.3,0.3,5.6,0.3,12S5.6,23.7,12,23.7S23.7,18.5,23.7,12S18.5,0.3,12,0.3z M12,21.7c-5.3,0-9.7-4.4-9.7-9.7c0-5.3,4.4-9.7,9.7-9.7c5.3,0,9.7,4.4,9.7,9.7C21.7,17.3,17.3,21.7,12,21.7z"
                        }), React.createElement("polygon", {
                          points: "19.8,9.8 12,17.6 4.2,9.8 5.6,8.4 12,14.8 18.4,8.4 "
                        }))
              };
    case /* UpCircle */33 :
        return {
                iconType: /* UpCircle */33,
                className: "upCircle",
                content: React.createElement("svg", {
                      id: "Layer_1",
                      version: "1.1",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M12,0.3C5.6,0.3,0.3,5.6,0.3,12S5.6,23.7,12,23.7S23.7,18.5,23.7,12S18.5,0.3,12,0.3z M12,21.7c-5.3,0-9.7-4.4-9.7-9.7c0-5.3,4.4-9.7,9.7-9.7c5.3,0,9.7,4.4,9.7,9.7C21.7,17.3,17.3,21.7,12,21.7z"
                        }), React.createElement("polygon", {
                          points: "4.2,14.2 12,6.4 19.8,14.2 18.4,15.6 12,9.2 5.6,15.6 "
                        }))
              };
    case /* ErrorCircle */34 :
        return {
                iconType: /* ErrorCircle */34,
                className: "errorCircle",
                content: React.createElement("svg", {
                      height: "24",
                      width: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("path", {
                          d: "M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                        }))
              };
    case /* TwoBags */35 :
        return {
                iconType: /* TwoBags */35,
                className: "twobags",
                content: React.createElement("svg", {
                      viewBox: "0 0 117.5 86.7",
                      x: "0px",
                      xmlns: "http://www.w3.org/2000/svg",
                      y: "0px"
                    }, React.createElement("polygon", {
                          points: "32.3,71.3 39.6,71.3 39.6,60.3 50.6,60.3 50.6,53 39.6,53 39.6,42 32.3,42 32.3,53 21.3,53 21.3,60.3 32.3,60.3 "
                        }), React.createElement("path", {
                          d: "M112.4,10.3h-10.3V5.1c0-2.8-2.3-5.1-5.1-5.1H86.7c-2.8,0-5.1,2.3-5.1,5.1v5.1H71.3c-2.8,0-5.1,2.3-5.1,5.1v12\n     c-0.3,0-0.6-0.1-0.9-0.1H50.6V20c0-4-3.3-7.3-7.3-7.3H28.6c-4,0-7.3,3.3-7.3,7.3v7.3H6.6c-4,0-7.3,3.3-7.3,7.3v44\n     c0,4,3.3,7.3,7.3,7.3h58.7c4,0,7.3-3.3,7.3-7.3V51.3h39.8c2.8,0,5.1-2.3,5.1-5.1V15.4C117.5,12.6,115.2,10.3,112.4,10.3z M28.6,20\n     h14.7v7.3H28.6V20z M65.3,78.6H6.6v-44h58.7V78.6z M86.7,5.1H97v5.1H86.7V5.1z M112.4,46.2H72.6V34.6c0-1.5-0.5-3-1.3-4.1V15.4\n     h41.1V46.2z"
                        }), React.createElement("polygon", {
                          points: "89.3,41.1 94.4,41.1 94.4,33.4 102.1,33.4 102.1,28.2 94.4,28.2 94.4,20.5 89.3,20.5 89.3,28.2 81.6,28.2\n     81.6,33.4 89.3,33.4 \t"
                        }))
              };
    case /* DollarSign */36 :
        return {
                iconType: /* DollarSign */36,
                className: "dollarsign",
                content: React.createElement("svg", {
                      viewBox: "0 0 96.7 107.4",
                      x: "0px",
                      xmlns: "http://www.w3.org/2000/svg",
                      y: "0px"
                    }, React.createElement("path", {
                          d: "M50.3,48.1c-11.6-3-15.4-6.1-15.4-11c0-5.6,5.2-9.5,13.8-9.5c9.1,0,12.5,4.4,12.8,10.8h11.3\n\tc-0.4-8.8-5.7-16.9-16.4-19.5V7.6H41.1v11.1c-9.9,2.2-17.9,8.6-17.9,18.5c0,11.8,9.8,17.7,24.1,21.2c12.8,3.1,15.4,7.6,15.4,12.3\n\tc0,3.5-2.5,9.2-13.8,9.2c-10.6,0-14.7-4.7-15.3-10.8H22.3c0.6,11.2,9,17.5,18.9,19.6v11.1h15.4v-11c10-1.9,17.9-7.7,17.9-18.2\n\tC74.4,56.1,62,51.1,50.3,48.1z"
                        }))
              };
    case /* Person */37 :
        return {
                iconType: /* Person */37,
                className: "person",
                content: React.createElement("svg", {
                      viewBox: "0 0 96.7 107.4",
                      x: "0px",
                      xmlns: "http://www.w3.org/2000/svg",
                      xmlnsXlink: "http://www.w3.org/1999/xlink",
                      y: "0px"
                    }, React.createElement("path", {
                          d: "M94,21.5c-14,3.8-30.5,5.4-45.7,5.4s-31.6-1.6-45.7-5.4L0,32.2c10.6,2.7,21.4,4.5,32.2,5.4v69.8H43V75.2h10.7\n\tv32.2h10.7V37.6c10.9-0.9,21.7-2.7,32.2-5.4L94,21.5z M48.3,21.5c5.9,0,10.7-4.8,10.7-10.7C59.1,4.8,54.3,0,48.3,0\n\tc-5.9,0-10.7,4.8-10.7,10.7C37.6,16.7,42.4,21.5,48.3,21.5L48.3,21.5z"
                        }))
              };
    case /* LogoShort */38 :
        return {
                iconType: /* LogoShort */38,
                className: "logoshort",
                content: React.createElement("svg", {
                      version: "1.1",
                      viewBox: "0 0 56.7 51",
                      x: "0px",
                      xmlns: "http://www.w3.org/2000/svg",
                      xmlnsXlink: "http://www.w3.org/1999/xlink",
                      y: "0px"
                    }, React.createElement("path", {
                          d: "M56.7,18.8c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.8,0.1-1.2,0.3c-0.2,0.1-0.4,0.2-0.6,0.3\n\tc-0.6,0.4-1.3,0.8-1.9,1.3c-0.6,0.4-1.1,0.9-1.7,1.3c-0.5,0.4-1,0.9-1.5,1.3c-0.2,0.1-0.3,0.3-0.5,0.4c0-0.4-0.1-0.8-0.1-1.2\n\tc0-0.3-0.1-0.6-0.1-0.8s-0.1-0.6-0.1-0.9s-0.1-0.6-0.1-0.9c0-0.3-0.1-0.7-0.1-1c0-0.2,0-0.5-0.1-0.7c0-0.4-0.1-0.8-0.1-1.2\n\tc0-0.3,0-0.6-0.1-0.9c0-0.5-0.1-0.9-0.1-1.4c0-0.3,0-0.6-0.1-1c0-0.5-0.1-0.9-0.1-1.4c0-0.7,0-1.4,0-2.1c0-0.4,0-0.9,0.1-1.3\n\tc0-0.1,0-0.3,0-0.4c0-0.4,0.1-0.8,0.1-1.2s0.1-0.8,0.2-1.2s0.1-0.8,0.2-1.2s0.1-0.8,0.2-1.2c0.1-0.4,0.1-0.7,0.2-1.1\n\tc0-0.3,0.1-0.5,0.1-0.8c0-0.3,0.1-0.6,0.1-0.9c0-0.2-0.1-0.3-0.2-0.4C48.5,0,48.4,0,48.2,0c-0.3,0-0.6,0-0.9,0.1\n\tc-0.7,0.1-1.5,0.3-2.1,0.7c-1,0.4-1.9,1-2.7,1.6c-0.7,0.5-1.4,1.1-2,1.7c-0.5,0.5-0.9,1-1.4,1.5c-0.4,0.4-0.7,0.9-1.1,1.4\n\tc-0.7,1-1.3,2.1-1.8,3.3c-0.3,0.7-0.6,1.5-0.8,2.3c-0.2,0.7-0.3,1.5-0.4,2.2c0,0.5-0.1,1.1-0.1,1.6c0,0.5,0,1,0.1,1.6\n\tc0,0.6,0.1,1.1,0.2,1.7c0.1,0.5,0.2,1,0.3,1.5c0.2,0.8,0.4,1.6,0.8,2.4c0.3,0.6,0.6,1.2,0.9,1.8c0.1,0.1,0.2,0.3,0.3,0.5\n\tc-1.9,0-3.8,0.2-5.6,0.6c0-0.1,0-0.1,0-0.2c0-0.3,0-0.6,0-0.9c0-0.4,0-0.9-0.1-1.3c-0.1-0.5-0.1-1.1-0.2-1.6\n\tc-0.1-0.4-0.1-0.9-0.2-1.3c-0.1-0.6-0.4-1.3-0.8-1.8c-0.1-0.3-0.5-0.4-0.8-0.2c-0.3,0.1-0.7,0.3-1,0.4c-0.4,0.2-0.8,0.4-1.3,0.6\n\tc-0.2,0.1-0.3,0.3-0.2,0.4c0,0.1,0.1,0.2,0.1,0.3c0.3,0.4,0.6,0.9,0.8,1.3c0.3,0.6,0.6,1.2,0.7,1.8c0,0.2,0.1,0.4,0.1,0.6l0,0\n\tc-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.2-0.4-0.3-0.6-0.5c-0.7-0.5-1.4-0.9-2.2-1.2c-0.7-0.3-1.4-0.4-2.2-0.5C23.1,22,22.6,22,22,22\n\tc-0.5,0-1,0-1.5,0.1c-0.5,0-1,0.1-1.5,0.2c-0.7,0.1-1.5,0.3-2.2,0.5c-0.9,0.3-1.8,0.7-2.6,1.2c-0.1,0-0.2,0.1-0.3,0.1\n\tc0-0.5-0.1-0.9-0.1-1.3c0-0.3-0.1-0.6-0.1-0.9c0-0.3-0.1-0.6-0.1-0.9c0-0.3-0.1-0.6-0.1-0.9c0-0.3-0.1-0.6-0.1-1\n\tc0-0.2,0-0.5-0.1-0.7c0-0.3-0.1-0.7-0.1-1c0-0.3,0-0.6-0.1-0.8c0-0.4-0.1-0.8-0.1-1.3s-0.1-0.8-0.1-1.3c0-0.6-0.1-1.1-0.1-1.7\n\tc0-0.8,0-1.6,0-2.5c0-0.3,0-0.6,0-0.9c0-0.1,0-0.3,0-0.4C13,8,13,7.6,13,7.2c0-0.3,0.1-0.6,0.1-0.9c0.1-0.4,0.1-0.8,0.2-1.2\n\tc0.1-0.4,0.1-0.9,0.2-1.3c0.1-0.5,0.2-1,0.3-1.5C13.9,1.7,14,1.3,14,0.8c0-0.2,0-0.4-0.1-0.5C13.9,0,13.6,0,13.4,0\n\tc-0.4,0-0.8,0-1.2,0.1c-0.6,0.1-1.3,0.3-1.9,0.6c-1,0.5-2,1.1-2.9,1.7C6.7,3,6.1,3.5,5.5,4.1C5.1,4.5,4.7,4.9,4.3,5.4\n\tc-0.4,0.5-0.8,1-1.2,1.5C2.5,7.8,2,8.7,1.5,9.6c-0.3,0.7-0.6,1.4-0.8,2.1C0.3,13,0.1,14.3,0,15.6c0,0.7,0,1.4,0,2\n\tc0,0.6,0.1,1.2,0.2,1.8c0.1,0.5,0.2,1,0.3,1.5c0.2,0.9,0.5,1.8,0.9,2.6c0.4,0.8,0.8,1.7,1.3,2.4c0.4,0.7,0.9,1.4,1.5,2\n\tc0.5,0.5,0.9,1.1,1.4,1.6c0.3,0.4,0.7,0.7,1.1,1.1c0.2,0.2,0.2,0.2,0,0.5c-0.5,0.8-1,1.6-1.4,2.4c-0.3,0.5-0.5,1-0.7,1.5\n\tc-0.3,0.7-0.6,1.4-0.8,2.1c-0.4,1.1-0.7,2.2-0.9,3.3c-0.1,0.5-0.2,1-0.3,1.5s-0.2,1-0.2,1.5c-0.1,0.4-0.1,0.9-0.1,1.3\n\tc0,0.6,0,1.1,0.1,1.7c0,0.3,0.1,0.6,0.1,0.9c0.1,0.5,0.2,1,0.4,1.4c0.2,0.6,0.6,1.1,1.1,1.5c0.7,0.5,1.6,0.8,2.5,0.6\n\tc0.5-0.1,1-0.3,1.5-0.6c0.6-0.4,1-0.8,1.5-1.3c0.3-0.3,0.5-0.6,0.8-1c0.4-0.6,0.8-1.2,1.1-1.9c0.4-0.7,0.7-1.3,1-2s0.5-1.4,0.7-2.1\n\tc0.2-0.8,0.4-1.6,0.6-2.4c0.2-1,0.4-2,0.5-3c0.1-0.7,0.2-1.3,0.2-2c0-0.4,0.1-0.9,0.1-1.3c0-0.4,0-0.8,0-1.2c0-0.4,0-0.8,0-1.2\n\ts0-0.8,0-1.2c0-0.6-0.1-1.2-0.1-1.8c0-0.5,0-0.9-0.1-1.4c0,0,0-0.1,0-0.1c-0.1-0.2,0-0.5,0.2-0.6c0.7-0.5,1.4-0.9,2.2-1.2\n\tc0.7-0.3,1.3-0.5,2-0.7c0,0.1,0,0.1,0,0.2c-0.1,0.5,0,1,0.1,1.4c0.2,0.6,0.6,1,1,1.4c0.5,0.4,1.1,0.7,1.8,1c0.7,0.3,1.5,0.5,2.3,0.5\n\tc0.5,0,1,0.1,1.4,0.1c0.7,0,1.4,0,2.1-0.1c0.3,0,0.6-0.1,1-0.1l0.9-0.1c0,0.1,0,0.2,0,0.3c0,0.6,0,1.1,0.1,1.7\n\tc0,0.4,0.1,0.7,0.1,1.1c0,0.2,0.1,0.4,0.3,0.5c0.3,0.2,0.7,0.1,0.9-0.1c0,0,0,0,0,0c0.2-0.3,0.4-0.6,0.5-1c0.1-0.4,0.2-0.8,0.3-1.2\n\tc0.1-0.5,0.1-0.9,0.2-1.4c0-0.2,0.2-0.4,0.4-0.5c0.5-0.1,1-0.2,1.5-0.3c0.7-0.2,1.5-0.3,2.3-0.3c0.8-0.1,1.6,0,2.3,0.1\n\tc0.2,0,0.5,0.1,0.6,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.3,0.3,0.6,0.7,0.9,1c0.4,0.4,0.8,0.9,1.2,1.3c0.3,0.3,0.5,0.5,0.8,0.8\n\tc0.1,0.1,0.1,0.1,0.1,0.2c-0.5,0.8-1,1.6-1.5,2.5c-0.5,0.9-0.9,1.8-1.3,2.7c-0.5,1-0.8,2.1-1.1,3.2c-0.1,0.5-0.3,1-0.4,1.5\n\tc-0.1,0.7-0.2,1.4-0.3,2.1c-0.1,0.5-0.1,1-0.1,1.5c0,0.6,0,1.2,0,1.8c0,0.2,0,0.4,0.1,0.7c0.1,0.5,0.2,1.1,0.4,1.6\n\tc0.2,0.7,0.6,1.2,1.2,1.7c0.5,0.4,1.1,0.6,1.8,0.7c0.4,0,0.8,0,1.2-0.2c0.7-0.2,1.4-0.6,1.9-1.2c0.4-0.3,0.7-0.7,1-1.1\n\tc0.6-0.8,1.1-1.6,1.5-2.5c0.4-0.8,0.8-1.7,1.1-2.6c0.4-1.1,0.7-2.1,1-3.2c0.2-0.8,0.4-1.7,0.5-2.5c0.1-0.6,0.2-1.2,0.3-1.9\n\tc0.1-0.5,0.1-1.1,0.2-1.6c0-0.5,0.1-1,0.1-1.5c0-0.4,0-0.7,0-1.1c0-0.7,0-1.4-0.1-2.1c0-0.4,0-0.9-0.1-1.3c0-0.5,0-1.1-0.1-1.6\n\tc0-0.3-0.1-0.6-0.1-0.9c0-0.2,0-0.4,0.2-0.6c0.3-0.3,0.6-0.6,1-0.9s0.6-0.6,1-0.9c0.5-0.4,1-0.8,1.5-1.2c0.6-0.5,1.3-1,1.9-1.4\n\ts1.3-0.9,1.9-1.3C56.6,19.4,56.8,19.1,56.7,18.8z M11.1,38.8c0,0.5-0.1,1-0.2,1.6c-0.1,1-0.3,1.9-0.6,2.9c-0.2,0.6-0.4,1.3-0.7,1.9\n\tc-0.3,0.6-0.6,1.1-1.1,1.6c-0.3,0.4-0.7,0.7-1.2,0.9c-0.7,0.4-1.5,0.2-2.1-0.3c-0.3-0.4-0.6-0.8-0.6-1.4c-0.1-0.3-0.1-0.6-0.1-0.9\n\tc0-0.3,0-0.5,0-0.8c0-0.5,0.1-1.1,0.1-1.6c0.1-1.1,0.3-2.1,0.6-3.1c0.3-1.1,0.6-2.1,1.1-3.1c0.3-0.8,0.7-1.5,1-2.3\n\tc0.5-1,1.1-2,1.8-2.9c0.4-0.5,0.8-1.1,1.2-1.6c0,0,0,0,0.1,0c0.1,0.4,0.1,0.8,0.2,1.1c0,0.3,0.1,0.5,0.1,0.8s0.1,0.5,0.1,0.8\n\tc0,0.3,0.1,0.6,0.1,0.9c0,0.3,0.1,0.7,0.1,1c0,0.1,0,0.3,0,0.4c0,0.2,0,0.4,0,0.7c0,0.7,0.1,1.5,0.1,2.2\n\tC11.2,37.8,11.2,38.3,11.1,38.8L11.1,38.8z M12.3,1.9c-0.1,0.3-0.2,0.5-0.3,0.8c-0.3,0.9-0.7,1.8-1,2.7c-0.3,0.8-0.6,1.5-0.8,2.3\n\tc-0.3,0.9-0.5,1.7-0.7,2.6c-0.2,0.7-0.3,1.3-0.4,2c-0.1,0.5-0.1,1.1-0.2,1.6c0,0.4-0.1,0.7-0.1,1.1c0,0.8-0.1,1.6-0.1,2.5\n\tc0,0.6,0.1,1.1,0.1,1.7c0,0.3,0.1,0.7,0.1,1c0,0.4,0.1,0.7,0.1,1.1c0.1,0.4,0.1,0.8,0.2,1.2c0.1,0.4,0.1,0.7,0.2,1.1\n\tc0.1,0.4,0.1,0.9,0.2,1.3c0.1,0.4,0.1,0.7,0.2,1.1S10,26.6,10,27c0,0.1,0,0.2-0.1,0.2c-0.2,0.3-0.5,0.5-0.7,0.8\n\tc-0.3,0.4-0.7,0.8-1,1.1c0,0,0,0-0.1,0.1c-0.2-0.3-0.3-0.5-0.5-0.7c-0.3-0.4-0.5-0.8-0.8-1.2c-0.4-0.7-0.8-1.3-1.1-2\n\tc-0.3-0.7-0.6-1.4-0.8-2.1c-0.2-0.7-0.4-1.4-0.5-2.1c-0.1-0.5-0.2-1-0.2-1.5c0-0.4-0.1-0.8-0.1-1.2c0-0.4,0-0.8-0.1-1.2s0-0.8,0-1.2\n\tc0-0.6,0-1.1,0.1-1.7c0.1-0.7,0.2-1.4,0.3-2.2c0.2-0.8,0.4-1.5,0.6-2.3C5.2,9.1,5.7,8,6.2,7.1c0.5-0.9,1-1.7,1.6-2.5\n\tC8.2,4.1,8.6,3.7,9,3.3c0.5-0.4,1-0.8,1.5-1.1c0.4-0.2,0.7-0.4,1.2-0.4c0.1,0,0.3,0,0.4,0C12.2,1.7,12.3,1.7,12.3,1.9\n\tC12.3,1.8,12.3,1.8,12.3,1.9L12.3,1.9z M27.3,26.9c-0.3,0-0.6,0-0.9,0c-0.8,0-1.6-0.1-2.4-0.3c-0.5-0.1-0.9-0.4-1.3-0.7\n\tc-0.2-0.2-0.3-0.5-0.3-0.8c0-0.4,0.3-0.8,0.7-0.9C23.5,24,24,24,24.4,24c1.3,0.2,2.5,0.7,3.5,1.6c0.3,0.3,0.6,0.6,0.9,1\n\tc0,0,0,0.1,0.1,0.1C28.3,26.8,27.8,26.9,27.3,26.9L27.3,26.9z M46,38.7c0,0.4-0.1,0.9-0.1,1.3c-0.1,0.5-0.1,1-0.2,1.4\n\tc-0.1,0.5-0.2,1.1-0.4,1.6c-0.2,0.7-0.5,1.5-0.8,2.1c-0.2,0.5-0.5,0.9-0.9,1.3c-0.3,0.4-0.8,0.7-1.3,1c-0.6,0.3-1.3,0.2-1.8-0.1\n\tc-0.3-0.2-0.5-0.4-0.6-0.7c-0.1-0.4-0.3-0.8-0.4-1.2c0-0.2-0.1-0.5-0.1-0.7c0-0.3,0-0.7,0-1c0-0.6,0.1-1.1,0.1-1.7\n\tc0.1-1.1,0.4-2.1,0.7-3.2c0.3-0.8,0.5-1.5,0.8-2.2c0.2-0.6,0.5-1.2,0.8-1.8c0.5-1,1.1-2,1.7-3c0.5-0.7,1-1.4,1.4-2.1\n\tc0.1-0.1,0.1-0.1,0.2-0.2c0,0.3,0.1,0.5,0.1,0.8c0.1,0.4,0.1,0.8,0.2,1.2c0,0.3,0.1,0.7,0.1,1c0,0.3,0.1,0.6,0.1,0.9\n\tc0,0.3,0.1,0.5,0.1,0.8c0,0.6,0.1,1.2,0.1,1.8c0,0.5,0,1,0,1.5C46.1,38,46,38.4,46,38.7z M47.1,1.9c-0.2,0.7-0.4,1.3-0.7,2\n\tc-0.3,0.8-0.6,1.5-0.9,2.2c-0.2,0.7-0.5,1.3-0.7,2c-0.2,0.8-0.4,1.7-0.6,2.5c-0.1,0.5-0.2,1.1-0.3,1.6c-0.1,0.4-0.1,0.7-0.1,1.1\n\ts-0.1,0.8-0.1,1.1c0,0.3-0.1,0.6-0.1,0.9c0,0.6,0,1.3,0,1.9c0,0.5,0.1,1,0.1,1.6c0,0.3,0.1,0.7,0.1,1c0.1,0.4,0.1,0.9,0.2,1.3\n\tc0.1,0.4,0.1,0.9,0.2,1.3c0.1,0.5,0.2,0.9,0.2,1.4c0.1,0.4,0.1,0.8,0.2,1.2s0.1,0.8,0.2,1.1c0,0.2,0.1,0.4,0.1,0.6\n\tc0,0.2-0.1,0.4-0.2,0.5c-0.5,0.6-1,1.3-1.5,1.9c0,0,0,0.1-0.1,0.1c-0.2-0.3-0.4-0.6-0.6-0.9c-0.4-0.5-0.7-1.1-1-1.6\n\tc-0.4-0.6-0.7-1.3-1-2c-0.3-0.6-0.5-1.2-0.7-1.7c-0.2-0.7-0.4-1.5-0.5-2.2c-0.1-0.5-0.2-1-0.2-1.5c-0.1-0.5-0.1-0.9-0.1-1.4\n\tc0-0.6-0.1-1.1-0.1-1.7c0-0.6,0-1.2,0.1-1.8c0.1-1.2,0.3-2.4,0.6-3.6c0.2-0.9,0.5-1.7,0.9-2.6c0.5-1.1,1.1-2.2,1.8-3.2\n\tc0.3-0.5,0.7-0.9,1.1-1.3c0.5-0.5,1-1,1.6-1.4c0.4-0.3,0.9-0.5,1.4-0.6c0.2-0.1,0.4-0.1,0.7-0.1C47,1.7,47.1,1.7,47.1,1.9z"
                        }))
              };
    case /* DoctorCircle */39 :
        var tmp = {
          viewBox: "0 0 93.57955 93.58382",
          xmlns: "http://www.w3.org/2000/svg"
        };
        if (fill !== undefined) {
          tmp.fill = Caml_option.valFromOption(fill);
        }
        return {
                iconType: /* DoctorCircle */39,
                className: "doctorcircle",
                content: React.createElement("svg", tmp, React.createElement("path", {
                          d: "M77.59224,11.55354A46.79969,46.79969,0,0,0,15.96187,81.99886c.50684.44824,1.02979.88769,1.55371,1.30664.61768.5,1.25733.98632,1.95117,1.48242a45.929,45.929,0,0,0,8.9585,5.04883l.13232.0625c.53418.22558,1.07764.4414,1.65039.65918l.11182.04394c.53418.19824,1.0752.39551,1.59814.5625a45.26882,45.26882,0,0,0,7.10352,1.77539,47.06158,47.06158,0,0,0,15.73145-.03711,45.709,45.709,0,0,0,6.98779-1.76758c.46826-.15918.93945-.32617,1.36279-.48632.16553-.05762.32373-.11719.47119-.17578.53321-.20313,1.05616-.41309,1.57032-.64454a1.86981,1.86981,0,0,0,.19189-.08105,46.08465,46.08465,0,0,0,8.80811-5c.63769-.46973,1.26709-.94336,1.88232-1.43652.5293-.42383,1.05176-.86231,1.5625-1.3125A46.71673,46.71673,0,0,0,92.74117,55.61409l.83691,3.34766L93.57955,46.783A46.799,46.799,0,0,0,77.59224,11.55354ZM29.812,87.17561l-.13184-.0625c-.1084-.04589-.21325-.09985-.32129-.14672a9.5961,9.5961,0,0,0-.04687-1.78711,55.74054,55.74054,0,0,1,.168-13.24707c.23291-1.578.62109-3.134.93506-4.70508.11718.01513.23291.03613.35107.051.01514.321.043.636.043.957q.01153,9.67439.02753,19.34961C30.47078,87.44222,30.11379,87.30074,29.812,87.17561ZM63.95064,87.077c-.43335.19653-.8783.373-1.34082.55.02069-4.938.01977-9.87146.02685-14.80981v-6.071a.94158.94158,0,0,1,.51905.62109,58.60471,58.60471,0,0,1,1.21289,7.57691c.15918,3.7771-.125,7.57715-.15283,11.36914a6.1463,6.1463,0,0,0,.04754.62732c-.03741.01623-.07354.03528-.111.05139Zm12.67548-8.2688a68.50393,68.50393,0,0,0-.37275-7.094c-1.20019-11.157-6.1372-20.144-15.33593-26.683-1.34522-.9569-2.75391-1.819-4.106-2.718-.665,2.163-1.125,4.209-1.91406,6.108-1.31494,3.14892-3.09082,5.96191-6.64893,7.06494-.22607.073-.562.395-.54785.577a14.30156,14.30156,0,0,0,.541,3.777,12.10608,12.10608,0,0,0,2.06689,2.74,6.03118,6.03118,0,0,1,1.22119,5.853,29.19576,29.19576,0,0,1-1.3999,3.51392c-.4668.99414-1.01611,1.834-.665,3.105a2.542,2.542,0,0,1-1.98,3.00061q-.06959.0141-.13916.02453a2.72108,2.72108,0,0,1-3.208-1.92211c-.3789-1.52.34424-3.13392,1.75977-3.34595a2.875,2.875,0,0,0,2.2998-1.929c2.05322-4.209,1.80615-5.44311-.84717-8.3291a7.20672,7.20672,0,0,1-2-6.04992c.1001-.745-.21191-1.016-.82519-1.322A10.91,10.91,0,0,1,42.041,53.53523a15.80174,15.80174,0,0,1-4.32519-7.67212c-.31494-1.09985-.52-2.22094-.79981-3.44091a10.33292,10.33292,0,0,0-.979.48193c-1.856,1.3-3.77783,2.521-5.55322,3.93115A33.25258,33.25258,0,0,0,18.78365,64.2762,54.64723,54.64723,0,0,0,16.89943,78.786,43.79337,43.79337,0,1,1,90.57759,46.39046l.00049.38769A43.70919,43.70919,0,0,1,76.62612,78.80818Z"
                        }), React.createElement("path", {
                          d: "M58.77535,16.5721a2.15521,2.15521,0,0,0-1.43116-.75293c-1.206-.1-2.42578-.029-3.70507-.029V13.69026c.75976-.051,1.4331-.1001,2.43994-.16113-1.20606-.833-2.38916-1.27893-2.96-2.13294a10.57852,10.57852,0,0,0-4.6001-3.9H45.17085a14.64009,14.64009,0,0,0-2.7539,1.629c-1.5,1.4-2.667,3.14905-4.544,4.14294-.03808.022-.02978.13208-.08789.38013h2.45313v2.13391c-1.416,0-2.7461-.051-4.0752.022a1.95257,1.95257,0,0,0-1.293.6,14.07784,14.07784,0,0,0-2.71923,8.57007,14.58308,14.58308,0,1,0,26.624-8.40015Zm-8.07276-1.94385a3.92646,3.92646,0,1,1,.001-.06519Z"
                        }), React.createElement("path", {
                          d: "M51.375,40.04109a1.18824,1.18824,0,0,0-1.4502.38208c-1.03076,1.064-2.11084,2.083-3.21094,3.16406a1.67805,1.67805,0,0,1-.25488-.167,28.81168,28.81168,0,0,1-2.36719-2.508,2.07878,2.07878,0,0,0-2.77-.71c-2.21875.813-2.30859.771-1.88183,3.091a15.58263,15.58263,0,0,0,4.13183,8.6c2.08789,2.072,4.23975,2.08911,6.3628.072a13.80653,13.80653,0,0,0,3.90576-7.491C54.58834,40.7701,55.24654,41.4471,51.375,40.04109Z"
                        }))
              };
    case /* DrugCircle */40 :
        var tmp$1 = {
          viewBox: "0 0 93.61203 93.61225",
          xmlns: "http://www.w3.org/2000/svg"
        };
        if (fill !== undefined) {
          tmp$1.fill = Caml_option.valFromOption(fill);
        }
        return {
                iconType: /* DrugCircle */40,
                className: "drugcircle",
                content: React.createElement("svg", tmp$1, React.createElement("path", {
                          d: "M93.611,46.80658a46.77548,46.77548,0,1,0-38.82471,46.125A46.622,46.622,0,0,0,74.16712,84.7851a47.2612,47.2612,0,0,0,13.7212-15.54,46.616,46.616,0,0,0,5.72363-22.43848Zm-2.999.00586a43.61123,43.61123,0,0,1-5.355,20.99219A44.23371,44.23371,0,0,1,72.41078,82.35248a43.63033,43.63033,0,0,1-18.13037,7.62207A43.77608,43.77608,0,0,1,21.2516,82.37982,43.8005,43.8005,0,0,1,39.73353,3.58588a44.41726,44.41726,0,0,1,7.1709-.58594A43.823,43.823,0,0,1,90.61195,46.80951Z"
                        }), React.createElement("path", {
                          d: "M70.28712,17.28754c-2.33106-2.34009-2.25684-2.256-4.65283-.02905-1.479,1.37011-1.61182,2.448.04492,3.62207.62793.44091,1.3081.807,1.62012,1-3.23389,3.22607-4.29981,4.286-7.16309,7.146-.80811-.824-1.748-1.844-2.748-2.8-4.02978-3.87988-2.585-4.03-6.97607.18311-1.01221.97388-.875,1.781.11182,2.59985.89111.74109,1.79394,1.469,3.168,2.58911A23.00789,23.00789,0,0,0,51.292,33.3465Q40.08375,44.5055,28.9131,55.70941c-2.76807,2.772-2.76416,2.77613-.229,5.70008.0752.087.0669.25.10791.433-1.05322,1.249-3.33789,2.339-.1001,4.525-6.04785,5.95691-2.91406,2.734-8.71093,8.441.34082.42493.67822.83692,1.14013,1.39991,5.89991-5.96094,2.7002-2.812,8.51612-8.68994,2.023,2.806,3.1709.458,4.47607-.574,2.938,2.464,2.93018,2.45606,5.687-.3q11.25073-11.26392,22.5-22.53686a7.72092,7.72092,0,0,0,1.07422-1.95313c4.73682,3.967,4.7002,3.938,7.91406.52515.916-.978.98584-1.707-.01709-2.593-1.74414-1.545-3.45117-3.12207-4.99121-4.51709,3.147-3.15893,4.16992-4.18994,6.97608-7.00806.15381.13306.416.337.6582.566,2.23486,2.119,2.231,2.12293,4.34619.01209a5.96078,5.96078,0,0,1,.44483-.437c1.30029-1.025,1.15234-1.92-.01856-3.04C75.82716,22.92755,73.07618,20.08856,70.28712,17.28754Zm-39.92676,45.876-.8999,1.027c.28613-.326.583-.662.8999-1.02795Zm1.273,3.60914v-.0011l.81006-1.04993C32.16847,66.07855,31.93751,66.37958,31.63331,66.77265Zm1.11523-1.44812-1.646-1.49109,1.647,1.489Zm-3.43945-6.985q2.6565-2.53638,5.458-5.2Zm7.46533,7.829-3.457-3.416,3.458,3.41394,3.65088-3.35693Zm7.06885-7.214c-2.28515-2.306-4.9082-4.954-7.67187-7.738l2.75488-2.55993c.7998,1,1.60693,2,2.519,3.13.582-.62793.97412-1.053,1.585-1.71-1.1831-.833-2.21-1.561-3.23877-2.28613l2.85987-2.87195c.729,1.06506,1.457,2.12708,2.248,3.28.749-.608,1.16114-.94006,1.76123-1.432-1.187-1.016-2.16113-1.85693-3.13476-2.693q1.45532-1.461,2.91015-2.91809l2.22315,3.751c.708-.82885,1.1001-1.27893,1.60693-1.87792-1.10009-.97-2.05175-1.819-3.00976-2.668q1.23633-1.26161,2.481-2.519c.79981,1,1.59424,1.994,2.5,3.126.58692-.62.98194-1.032,1.58985-1.678l-3.209-2.331c1.229-1.28589,2.457-2.57691,3.60889-3.788,2.73486,2.736,5.31592,5.31995,7.80518,7.80994Zm25.5918-17.225.001.004c-.37792.312-1.041.861-1.62011,1.34095-5.15381-5.162-10.32422-10.33606-15.68115-15.70691.5122-.42908,1.1372-.95313,1.64013-1.37806C58.94093,31.17658,64.09278,36.35858,69.43507,41.72956Zm-4.61231-8.501.00147.005c-.78809-.78308-1.7002-1.69006-2.585-2.573,2.77978-2.781,3.7622-3.75306,6.44677-6.43409.83594.92408,1.7002,1.881,2.5,2.772C68.59181,29.54157,67.60792,30.48554,64.82276,33.22858Zm11.43067-4.9801c-3.09278-3.106-6.11524-6.1399-9.41309-9.45386.26416-.20007.63721-.49207.833-.64209l9.34619,9.28393c-.15185.14917-.49756.51905-.76758.80713Z"
                        }))
              };
    case /* GearCircle */41 :
        var tmp$2 = {
          viewBox: "0 0 93.57967 93.58539",
          xmlns: "http://www.w3.org/2000/svg"
        };
        if (fill !== undefined) {
          tmp$2.fill = Caml_option.valFromOption(fill);
        }
        return {
                iconType: /* GearCircle */41,
                className: "gearcircle",
                content: React.createElement("svg", tmp$2, React.createElement("path", {
                          d: "M77.59236,11.55414A46.7999,46.7999,0,0,0,15.96248,82.00043c.50683.44727,1.02929.88672,1.55371,1.30567.625.50586,1.26562.99218,1.95019,1.48242a46.17669,46.17669,0,0,0,8.99122,5.0664l.10058.04688c.53516.22461,1.07813.44043,1.64258.65527l.11816.04688c.53418.19824,1.0752.39551,1.59961.5625a45.40556,45.40556,0,0,0,7.10254,1.77539,47.068,47.068,0,0,0,15.73242-.03711,45.69877,45.69877,0,0,0,6.98438-1.76758c.46973-.1582.94238-.32617,1.36133-.48535.168-.05762.32519-.11719.47656-.17676.53125-.20215,1.05273-.41211,1.56543-.64258a1.94994,1.94994,0,0,0,.19433-.083,46.00654,46.00654,0,0,0,8.80958-5c.63769-.46875,1.2666-.94239,1.88281-1.43653.52929-.42383,1.05176-.86328,1.56152-1.3125A46.72415,46.72415,0,0,0,93.10994,53.39887l.46875,1.1709.001-7.78614A46.79563,46.79563,0,0,0,77.59236,11.55414ZM90.57771,46.77973A43.73269,43.73269,0,0,1,75.60994,79.74555q-.71923.63428-1.458,1.22656c-.584.46777-1.17969.916-1.77441,1.35352a43.388,43.388,0,0,1-8.31641,4.708l-.11035.04493c-.47168.21386-.95215.40625-1.457.59863-.126.04883-.24414.09473-.41309.15332-.42773.16211-.86523.31641-1.30371.46387a42.60209,42.60209,0,0,1-6.5293,1.65332,44.11194,44.11194,0,0,1-14.73535.03515,42.57131,42.57131,0,0,1-6.65625-1.666c-.50293-.16113-1.001-.34278-1.50293-.5293l-.10742-.042c-.50976-.19434-1.01953-.39649-1.4668-.585l-.09863-.0459A43.30968,43.30968,0,0,1,21.21638,82.351c-.6416-.458-1.23437-.90918-1.82031-1.38281q-.73829-.59034-1.4541-1.22168A43.80029,43.80029,0,1,1,90.57771,46.3393Z"
                        }), React.createElement("path", {
                          d: "M69.87062,38.98871l-4.77686-8.26208a1.2171,1.2171,0,0,0-1.46923-.548l-5.94678,2.38892a17.58912,17.58912,0,0,0-4.03223-2.33887l-.8999-6.322a1.2001,1.2001,0,0,0-1.19482-1.02H41.99464a1.17989,1.17989,0,0,0-1.16992,1.02l-.8999,6.322a17.9525,17.9525,0,0,0-4.03223,2.33887l-5.94677-2.38892a1.18886,1.18886,0,0,0-1.46924.548l-4.752,8.26208a1.13023,1.13023,0,0,0,.29981,1.51795l5.05176,3.932a13.88145,13.88145,0,0,0-.04981,4.678l-5.05176,3.932a1.22086,1.22086,0,0,0-.2998,1.51794l4.77685,8.26209a1.217,1.217,0,0,0,1.46924.547l5.94678-2.38892a17.60239,17.60239,0,0,0,4.03223,2.34l.8999,6.32092A1.22506,1.22506,0,0,0,42,70.66864h9.55616a1.1619,1.1619,0,0,0,1.16992-1.021l.8999-6.32092a17.09545,17.09545,0,0,0,4.03223-2.34L63.605,63.37568a1.19,1.19,0,0,0,1.47021-.547l4.77686-8.26209a1.15093,1.15093,0,0,0-.29981-1.51794l-5.00732-3.932a17.506,17.506,0,0,0,.148-2.339,14.37289,14.37289,0,0,0-.17286-2.339l5.05079-3.932A1.2183,1.2183,0,0,0,69.87062,38.98871ZM55.7339,46.77863a8.959,8.959,0,1,1,0-.002Z"
                        }))
              };
    case /* CriminalCircle */42 :
        var tmp$3 = {
          viewBox: "0 0 93.98364 93.98547",
          xmlns: "http://www.w3.org/2000/svg"
        };
        if (fill !== undefined) {
          tmp$3.fill = Caml_option.valFromOption(fill);
        }
        return {
                iconType: /* CriminalCircle */42,
                className: "criminalcircle",
                content: React.createElement("svg", tmp$3, React.createElement("path", {
                          d: "M74.40844,8.81458a46.99391,46.99391,0,1,0-19.417,84.4873A46.82783,46.82783,0,0,0,74.4563,85.12219,47.49,47.49,0,0,0,88.23462,69.51575,46.84412,46.84412,0,0,0,93.95923,48.4845l.02441-1.5A47.11033,47.11033,0,0,0,74.40844,8.81458ZM85.9765,67.33972c-2.16315-3.33716-4.24518-6.73572-6.42078-10.19159-4.40283,2.176-8.623,4.276-13.2749,6.576,2.29657,6.35352,4.54742,12.5315,6.763,18.70184-.11633.08576-.22717.17908-.34436.26362a43.81093,43.81093,0,0,1-18.21387,7.65527,43.96286,43.96286,0,0,1-33.17675-7.62891c-.11457-.08233-.22272-.171-.33631-.25427,1.46509-3.96643,2.953-7.92242,4.34393-11.90656.82129-2.341,1.34327-4.787,2.03321-7.287-4.49219-1.749-8.771-3.405-13.18946-5.12207-1.01953,1.599-1.93554,3.097-2.90576,4.557Q9.658,65.0958,8.04345,67.48853A44.0045,44.0045,0,1,1,90.97973,46.38782l.001.59961A43.81423,43.81423,0,0,1,85.9765,67.33972Z"
                        }), React.createElement("path", {
                          d: "M62.9107,52.39014a1.92729,1.92729,0,0,0,1.30908-.233c2.752-1.313,5.50977-2.63,8.229-4.016,2.98486-1.517,2.97314-1.549,2.479-4.951-.74511-5.13-3.36377-9.974-2.312-15.369.01318-.065.05615-1.876-1.64307-1.945a2.653,2.653,0,0,0-1.8999,1.4,23.81927,23.81927,0,0,0-1.125,4.016,8.25139,8.25139,0,0,1,.5791-5.945,1.66474,1.66474,0,0,0-.46093-2.2c-.31787-.314-1.6001-.11-2.08789.3-1.47217,1.248-2.58887,2.757-2.332,4.918a12.75331,12.75331,0,0,1-.167,2.447c-.228,0-.457-.012-.68506-.021-.62011-2.528-1.14306-5.023.11817-7.67a1.52638,1.52638,0,0,0,.07715-.193,1.63506,1.63506,0,0,0-2.29-1.9,2.13453,2.13453,0,0,0-.52588.329c-1.93311,1.688-2.04785,4.013-1.688,6.394.1709,1.138.2998,2.283.44385,3.421a7.01881,7.01881,0,0,1-2.1001-5.795,11.61284,11.61284,0,0,0,.02-2.643c-.167-1.313-1.0918-1.725-1.94922-.779a7.87763,7.87763,0,0,0-1.69189,3.275c-1.04786,4.151.63281,8,1.61816,11.911a43.87243,43.87243,0,0,0,1.686,4.551l-.38819.265a44.5546,44.5546,0,0,0-3.479-3.046,1.24434,1.24434,0,0,0-.42285-.191,1.30464,1.30464,0,0,0-1.59864,1.73C52.80572,46.38013,57.13238,50.15509,62.9107,52.39014Z"
                        }), React.createElement("path", {
                          d: "M19.98785,48.3891c3.4502,1.236,6.83887,2.638,10.29981,3.857a4.08336,4.08336,0,0,0,2.46777-.065c5.23389-1.762,8.21582-5.79095,10.292-10.623.022-.054.042-.108.05908-.164a1.42795,1.42795,0,0,0-2.165-1.532c-.022.014-.042.029-.063.044a38.54252,38.54252,0,0,0-3.24219,2.944,42.62978,42.62978,0,0,1,1.46387-5.264c1.042-4.041,2.52295-8.045,1.42187-12.356-.38281-1.5-1.4751-3.677-2.916-2.956-1.63184.815-.81592,2.447-.731,3.254.02685.252.03418.538.07422.807.32715,2.23-.62793,4.041-2.19287,5.725.228-1.463.46-2.924.68408-4.387a6.04548,6.04548,0,0,0-1.98584-5.7,1.45763,1.45763,0,0,0-.29981-.2,1.72087,1.72087,0,0,0-2.458,1.684,1.75525,1.75525,0,0,0,.01709.209,5.652,5.652,0,0,0,.58691,1.285c.731,1.855.30615,5.452-1,6.859a23.483,23.483,0,0,1-.10986-2.541,5.3,5.3,0,0,0-2.15284-4.8,1.48615,1.48615,0,0,0-.335-.188,1.79993,1.79993,0,0,0-2.40722,1.9c.00488.047.01123.094.01806.14.31006,1.872.79981,3.715,1.22315,5.571l-.68408.159a19.56923,19.56923,0,0,0-1.02881-3.792,1.42209,1.42209,0,0,0-.1001-.175,1.90021,1.90021,0,0,0-3.186.165,4.23753,4.23753,0,0,0-.23681.451c-.228.509.01318,1.211-.062,1.81-.29981,2.536-.57911,5.081-.99121,7.6-.44825,2.74-1.03223,5.456-1.56885,8.176C18.45514,47.41809,18.88678,47.99408,19.98785,48.3891Z"
                        }), React.createElement("path", {
                          d: "M35.49957,55.72211a5.28586,5.28586,0,0,0-1.21484,1.031l.20019.037a11.77729,11.77729,0,0,1,1.98584.522c.19092.065.38184.122.5791.184.32178.1.65576.2.98194.326a3.06259,3.06259,0,0,1,1.36181.963l3.36377.783a1.61928,1.61928,0,0,1,.51319.216,1.69823,1.69823,0,0,1,.61181-.11,1.13485,1.13485,0,0,1,.12207,0l3.57178.228a5.23489,5.23489,0,0,0-.64893-1.521,5.33119,5.33119,0,0,0-3.335-2.389l-4.04882-.942A5.32713,5.32713,0,0,0,35.49957,55.72211Z"
                        }), React.createElement("path", {
                          d: "M42.68072,63.70209a1.69893,1.69893,0,0,1-.686-.016l-3.9458-.918a3.30691,3.30691,0,0,1-1.06787.2,1.89781,1.89781,0,0,1-.39209-.037c-.82813-.179-1.19092-.228-1.46-.265a8.6334,8.6334,0,0,1-1.9248-.509c-.044-.017-.09277-.03295-.13818-.04595a5.23074,5.23074,0,0,0,.71289,1.811,5.3254,5.3254,0,0,0,3.335,2.389l4.0498.942a5.46813,5.46813,0,0,0,1.22705.143,5.37258,5.37258,0,0,0,4.8169-3.026l-3.43408-.22A1.849,1.849,0,0,1,42.68072,63.70209Z"
                        }), React.createElement("path", {
                          d: "M52.62359,60.45612l3.28223-.881a4.6283,4.6283,0,0,1,1.94922-1.358,15.02166,15.02166,0,0,0,1.44385-.71,12.25709,12.25709,0,0,1,1.18115-.6,5.10447,5.10447,0,0,0-.75391-.526,5.33092,5.33092,0,0,0-4.07422-.534l-4.01611,1.074a5.37151,5.37151,0,0,0-3.53076,3.046l3.68994.236A1.88184,1.88184,0,0,1,52.62359,60.45612Z"
                        }), React.createElement("path", {
                          d: "M60.04693,63.25708a4.80217,4.80217,0,0,1-1.91211.542,1.90154,1.90154,0,0,1-.81494-.171l-3.44092.925a1.63086,1.63086,0,0,1-1.00683-.045,1.78644,1.78644,0,0,1-.77881.175,1.02058,1.02058,0,0,1-.11914,0l-3.67822-.236a5.347,5.347,0,0,0,6.53222,3.654l4.01416-1.077a5.37073,5.37073,0,0,0,3.97119-5.069c-.853.392-.98681.456-1.23584.579C61.3526,62.63812,61.03473,62.79211,60.04693,63.25708Z"
                        }), React.createElement("path", {
                          d: "M36.67389,62.12415a1.44237,1.44237,0,0,0,.30713.029,2.42418,2.42418,0,0,0,.439-.04505,3.37174,3.37174,0,0,0,.331-.081c.105-.033.21094-.07.313-.11q.15308-.06189.29981-.139a2.752,2.752,0,0,0,.27588-.164,1.64564,1.64564,0,0,0,.49414-.481,1.50682,1.50682,0,0,0-.44092-2.08515c-.01611-.01056-.03272-.02087-.04932-.03082a3.13312,3.13312,0,0,0-.75781-.412c-.50586-.192-1.03223-.33-1.54492-.5a12.564,12.564,0,0,0-2.3501-.583,15.25948,15.25948,0,0,1-1.623-.469c.46-1.485.97022-2.757-.9458-3.454-4.78808-1.737-9.52588-3.6-14.269-5.448a2.82423,2.82423,0,0,0-1-.225,1.70052,1.70052,0,0,0-.25684.021,1.4783,1.4783,0,0,0-.23291.065c-.03711.012-.07324.029-.10986.045a1.32012,1.32012,0,0,0-.2998.208,1.61286,1.61286,0,0,0-.25684.306c-.05322.078-.1001.163-.15478.257a4.36525,4.36525,0,0,0-.2002.473,46.77136,46.77136,0,0,1-1.9458,4.918c-.82715,1.684-.23584,2.442,1.35791,3.026,4.13916,1.517,8.25293,3.115,12.36377,4.718a8.585,8.585,0,0,0,2.53223.775,1.2562,1.2562,0,0,0,.416-.065,1.35031,1.35031,0,0,0,.252-.119,2.86394,2.86394,0,0,0,.7002-.656q.10473-.129.22021-.282c.2002-.261.4292-.575.69-.942.5791.188,1.16894.379,1.76513.579l.334.11A17.07679,17.07679,0,0,0,36.67389,62.12415Z"
                        }), React.createElement("path", {
                          d: "M78.67584,48.62213c-.02783-.065-.05811-.127-.08594-.188s-.04785-.1-.07324-.147c-.0332-.065-.06885-.131-.1001-.192a1.51775,1.51775,0,0,0-.09424-.151c-.02-.032-.041-.061-.061-.094-.04492-.061-.085-.114-.12988-.167a1.28909,1.28909,0,0,0-.1001-.114c-.00781-.008-.01221-.016-.02-.024a.69258.69258,0,0,0-.083-.078c-.00781,0-.01123-.012-.02-.016a.5668.5668,0,0,0-.061-.053,1.01505,1.01505,0,0,0-.13916-.1,1.28485,1.28485,0,0,0-.23194-.122,1.47516,1.47516,0,0,0-.52588-.094,3.26767,3.26767,0,0,0-1.44287.436q-6.14208,3.163-12.41406,6.072c-1.749.815-3.0249,1.66-1.60693,3.89-.09424.045-.18311.086-.26514.126-.18311.086-.33789.159-.46924.225-.06494.032-.12207.057-.1792.086s-.1001.053-.147.073l-.23584.118c-.07715.045-.13916.077-.19189.106-.03223.017-.05713.037-.085.049a.5406.5406,0,0,0-.07421.045,1.36177,1.36177,0,0,0-.12989.069.21055.21055,0,0,1-.05322.029.08435.08435,0,0,1-.02881.016.11928.11928,0,0,1-.03711.016c-.04492.025-.1001.049-.15478.078-.07715.037-.1709.086-.27686.134s-.23682.114-.38721.183c-.10009.049-.208.1-.33007.156s-.249.118-.37207.175l-.35889.184c-.05713.032-.11279.061-.16992.1s-.12207.073-.18311.11-.10986.073-.16015.11-.1001.078-.14991.118a1.8965,1.8965,0,0,0-.3999.44c-.021.029-.03613.057-.05322.086a1.65007,1.65007,0,0,0,.021,1.513q.06372.15.14209.293a4.04018,4.04018,0,0,0,.16407.249c.02783.037.05713.073.08593.106a.91493.91493,0,0,0,.08789.094,1.49883,1.49883,0,0,0,.123.106.355.355,0,0,0,.06494.049.94364.94364,0,0,0,.123.077,1.58367,1.58367,0,0,0,.167.078c.041.016.07813.029.11914.041a.32013.32013,0,0,0,.05616.016c.0332.00867.0664.01569.10009.021a.43636.43636,0,0,0,.06787.008.53264.53264,0,0,0,.11524.012.91516.91516,0,0,0,.10986,0,4.32635,4.32635,0,0,0,1.74121-.506c.123-.057.23291-.11.335-.159.126-.057.24121-.11.33789-.159l.13086-.062c.01221,0,.02393-.012.03614-.016.042-.021.082-.037.11914-.053.10009-.049.1792-.09.251-.123s.13086-.061.18506-.09c.03321-.016.06494-.029.09424-.045l.05322-.025c.03321-.016.062-.029.08985-.045l.30615-.142c.02783-.012.061-.029.09424-.045.05176-.021.10986-.049.18017-.082s.14209-.065.228-.106c.06494-.029.14209-.061.22412-.1s.15186-.07.23682-.11a.11222.11222,0,0,0,.02783-.012c.10889-.053.23193-.11.36816-.171.19483.321.36621.652.54493.958.07421.118.14306.237.22119.347.04883.069.10009.139.15088.2a2.09044,2.09044,0,0,0,.1499.175,1.36408,1.36408,0,0,0,.16406.151.1422.1422,0,0,0,.04.032c.041.032.082.061.126.09l.01318.008a1.10726,1.10726,0,0,0,.12988.07.61564.61564,0,0,0,.13379.048.274.274,0,0,0,.082.025h.00782a.727.727,0,0,0,.10009.021h.05176a1.0712,1.0712,0,0,0,.16406.012,2.59887,2.59887,0,0,0,1.17481-.35c4.50537-2.316,9.07617-4.539,13.65137-6.748,1.25976-.612,1.53711-1.383.91894-2.594C80.20514,51.79913,79.376,50.23712,78.67584,48.62213Z"
                        }), React.createElement("path", {
                          d: "M52.09381,63.87109a1.36992,1.36992,0,0,0,.293-.033,1.28685,1.28685,0,0,0,.47216-.192,2.045,2.045,0,0,0,.208-.159,1.43491,1.43491,0,0,0,.44922-.95v-.09a.81788.81788,0,0,0-.00781-.138l-.01318-.094a.70149.70149,0,0,0-.01612-.09c-.0122-.045-.0249-.09-.03711-.13a.90626.90626,0,0,0-.04-.106c-.01709-.037-.0332-.069-.0498-.1a.529.529,0,0,0-.061-.10595,1.572,1.572,0,0,0-.09423-.131,1.12619,1.12619,0,0,0-.10987-.123c-.0249-.024-.05322-.048-.082-.073s-.05713-.048-.08594-.069a1.42,1.42,0,0,0-.3999-.2.75486.75486,0,0,0-.106-.029.71624.71624,0,0,0-.09277-.021c-.04492-.008-.09424-.012-.13916-.016l-3.81689-.249-.7002-.045-3.688-.237h-.08886a.4118.4118,0,0,0-.065,0,.283.283,0,0,1-.061,0h-.01318a.76587.76587,0,0,0-.1001.012.52924.52924,0,0,0-.08985.02h-.01709l-.085.024a1.66937,1.66937,0,0,0-.1792.073,1.20113,1.20113,0,0,0-.10986.057.91113.91113,0,0,0-.085.057.195.195,0,0,1-.04492.029.142.142,0,0,0-.04.032.61621.61621,0,0,0-.082.07,1.495,1.495,0,0,0-.17188.2,1.62793,1.62793,0,0,0-.13916.225,1.42928,1.42928,0,0,0-.13916.53,1.41,1.41,0,0,0,.01319.294v.017a.02954.02954,0,0,0,0,.016c.00878.045.01709.086.0288.131a1.56978,1.56978,0,0,0,.10889.285c0,.008.00879.012.01318.02a.90313.90313,0,0,0,.04883.09l.01221.016a.33944.33944,0,0,0,.041.061c.01709.021.0332.041.04492.057a.74125.74125,0,0,0,.10009.11.792.792,0,0,0,.12208.11.25071.25071,0,0,0,.042.032.9313.9313,0,0,0,.105.074,1.37656,1.37656,0,0,0,.12988.069.54678.54678,0,0,0,.07813.032c.04394.017.084.033.1289.046a.81545.81545,0,0,0,.13916.032,1.13606,1.13606,0,0,0,.17481.024l3.581.229.812.053,3.80909.244A.66209.66209,0,0,0,52.09381,63.87109Z"
                        }))
              };
    case /* HospCircle */43 :
        var tmp$4 = {
          viewBox: "0 0 93 93",
          xmlns: "http://www.w3.org/2000/svg"
        };
        if (fill !== undefined) {
          tmp$4.fill = Caml_option.valFromOption(fill);
        }
        return {
                iconType: /* HospCircle */43,
                className: "hospcircle",
                content: React.createElement("svg", tmp$4, React.createElement("path", {
                          d: "M68.81061,44.72815l-.00244-.002a7.3,7.3,0,0,0-10.3208,0l-1.36524,1.366H24.4693a7.29987,7.29987,0,0,0-7.29981,7.3H60.14655Z"
                        }), React.createElement("polygon", {
                          points: "77.909 39.236 61.2 55.945 17.169 55.945 17.169 61.053 63.322 61.053 81.521 42.848 77.909 39.236"
                        }), React.createElement("circle", {
                          cx: "23.49988",
                          cy: "66.50012",
                          r: "4"
                        }), React.createElement("circle", {
                          cx: "56.59589",
                          cy: "66.81213",
                          r: "3.64899"
                        }), React.createElement("circle", {
                          cx: "69.00188",
                          cy: "36.89214",
                          r: "5.10798",
                          transform: "translate(-6.63023 16.84038) rotate(-13.28259)"
                        }), React.createElement("path", {
                          d: "M51.87183,17.77911h5.43408a1.479,1.479,0,0,1,1.479,1.479v8.016a1.479,1.479,0,0,1-1.479,1.479h-5.434a1.479,1.479,0,0,1-1.479-1.479V19.25806A1.47894,1.47894,0,0,1,51.87183,17.77911Z"
                        }), React.createElement("path", {
                          d: "M53.74487,15.84216h1.688a.447.447,0,0,1,.447.447v.397a.447.447,0,0,1-.447.447h-1.688a.447.447,0,0,1-.447-.447v-.397A.447.447,0,0,1,53.74487,15.84216Z"
                        }), React.createElement("path", {
                          d: "M54.38287,29.59515v12.018a2.94626,2.94626,0,0,0,2.94287,2.94195v-.72894a2.216,2.216,0,0,1-2.21386-2.213v-12.018Z"
                        }), React.createElement("path", {
                          d: "M46.5,0A46.5,46.5,0,1,0,93,46.5,46.55272,46.55272,0,0,0,46.5,0Zm0,90A43.5,43.5,0,1,1,90,46.5,43.54945,43.54945,0,0,1,46.5,90Z"
                        }))
              };
    case /* RelaspeCircle */44 :
        var tmp$5 = {
          viewBox: "0 0 94 93",
          xmlns: "http://www.w3.org/2000/svg"
        };
        if (fill !== undefined) {
          tmp$5.fill = Caml_option.valFromOption(fill);
        }
        return {
                iconType: /* RelaspeCircle */44,
                className: "relaspecircle",
                content: React.createElement("svg", tmp$5, React.createElement("path", {
                          d: "M58.35852,33.6701a10.76654,10.76654,0,0,0-2.6499,1.9c-2.73291,2.589-6.146,3.483-9.707,4.052-1.26172.2-1.72071-.269-1.29981-1.559a37.08354,37.08354,0,0,0,1.3999-4.959c.127-.714-.19091-2.015-.66308-2.222a3.77475,3.77475,0,0,0-2.87793.028,4.19944,4.19944,0,0,0-1.8999,2.3,30.426,30.426,0,0,0-1.30518,6.208c-.37207,4.062.71484,5.3,4.728,4.731a63.23858,63.23858,0,0,0,9.94922-2.647c1.1997-.375,1.898-.341,2.17675.925.57374,2.571,1.00586,5.172,1.59083,7.737.751,3.296-1.44092,1.208-1.84913.908-2.21-1.639-4.33593-3.413-6.60009-4.983a4.91069,4.91069,0,0,0-2.61182-.649,41.23219,41.23219,0,0,0-5.13477.282,3.73682,3.73682,0,0,0-2.17675.8c-2.48828,2.629-4.85889,5.372-7.26807,8.078s-4.83789,5.387-7.22607,8.106c-.04346.04266-.085.08679-.125.13238a2.54026,2.54026,0,0,0,.23193,3.58466,2.963,2.963,0,0,0,3.86523.859,7.9644,7.9644,0,0,0,2.146-1.694q5.94507-6.597,11.85107-13.234c1.48389-1.667,1.47266-1.688,3.04981-.193q6.687,6.364,13.3999,12.7c2.83008,2.67,6.55322,1.963,7.62305-1.719a69.51324,69.51324,0,0,0,1.91162-11.509,36.49727,36.49727,0,0,0-3.21582-15.063C64.24866,33.56311,61.14075,32.32416,58.35852,33.6701Z"
                        }), React.createElement("path", {
                          d: "M47.28088,35.92017a6.78523,6.78523,0,0,0,7.54786-2.969v-.006a7.34508,7.34508,0,0,0-9.145-10.739,7.05752,7.05752,0,0,0-4.187,7.267C46.60071,27.91016,47.93176,29.43915,47.28088,35.92017Z"
                        }), React.createElement("path", {
                          d: "M47,0C21.084,0,0,20.85986,0,46.5S21.084,93,47,93,94,72.14014,94,46.5,72.916,0,47,0Zm0,90C22.73828,90,3,70.48584,3,46.5S22.73828,3,47,3,91,22.51416,91,46.5,71.26172,90,47,90Z"
                        }))
              };
    case /* HealthyCircle */45 :
        var tmp$6 = {
          viewBox: "0 0 93 93",
          xmlns: "http://www.w3.org/2000/svg"
        };
        if (fill !== undefined) {
          tmp$6.fill = Caml_option.valFromOption(fill);
        }
        return {
                iconType: /* HealthyCircle */45,
                className: "healthycircle",
                content: React.createElement("svg", tmp$6, React.createElement("path", {
                          d: "M61.90179,34.51715c-2.8081-1.864-5.69384-3.615-8.5498-5.407-.5-.316-1.0249-.6-1.34424-.77905-.89209-.42395-9.687-.42395-10.647-.136a6.68059,6.68059,0,0,0-.71289.347c-2.10694,1.262-4.22217,2.51606-6.30811,3.814-1.22217.759-2.4209,1.559-3.585,2.4a4.23911,4.23911,0,0,0-1.1001,6.255,10.1605,10.1605,0,0,0,2.3208,2.417c1.95215,1.4,4.021,2.629,6.03223,3.943.2168.142.5.369.522.582a5.29754,5.29754,0,0,1-.05175,1.638c-.772,3.6-1.58106,7.2-2.377,10.8-1.26709,5.743-2.56006,11.48-3.772,17.23395a4.53572,4.53572,0,0,0,.2002,2.353,3.1909,3.1909,0,0,0,3.13378,1.937,3.312,3.312,0,0,0,3.04493-2.534c.708-3.055,1.36816-6.122,2.04394-9.184q1.8003-8.116,3.6001-16.229c.0498-.229.271-.592.42383-.6,1.249-.049,2.5-.028,3.76416-.028.50879,2.3,1,4.521,1.48877,6.739q2.11377,9.571,4.231,19.14a3.29986,3.29986,0,0,0,3.77979,2.629c2.06592-.379,3.13281-2.139,2.64014-4.378-1.93506-8.78-3.88721-17.556-5.78614-26.344a11.32387,11.32387,0,0,1-.1372-3.042c.082-1.289,1.50586-1.146,2.18017-1.828a1.65862,1.65862,0,0,1,.332-.206,22.53873,22.53873,0,0,0,5.562-4.3C65.03461,39.16711,64.71674,36.38812,61.90179,34.51715Zm-23.38525,7.708-4.96289-3.591,4.96289-3.248Zm16.27588-.173h-.002v-6.47l4.63916,3.028C57.83344,39.79614,56.38763,40.87012,54.79242,42.05212Z"
                        }), React.createElement("path", {
                          d: "M46.687,25.71173a7.06869,7.06869,0,0,0,7.08154-7.0556,7.06875,7.06875,0,1,0-14.1372-.026A7.06859,7.06859,0,0,0,46.687,25.71173Zm4.11524-5.3866c-.001,1.55988-1.82892,2.82569-4.0835,2.82593-2.25458-.00024-4.08252-1.265-4.08252-2.82593Z"
                        }), React.createElement("path", {
                          d: "M46.5,0A46.5,46.5,0,1,0,93,46.5,46.55272,46.55272,0,0,0,46.5,0Zm0,90A43.5,43.5,0,1,1,90,46.5,43.54945,43.54945,0,0,1,46.5,90Z"
                        }))
              };
    case /* CalendarCircle */46 :
        var tmp$7 = {
          viewBox: "0 0 93.6 93.6",
          xmlns: "http://www.w3.org/2000/svg"
        };
        if (fill !== undefined) {
          tmp$7.fill = Caml_option.valFromOption(fill);
        }
        return {
                iconType: /* CalendarCircle */46,
                className: "calendarcircle",
                content: React.createElement("svg", tmp$7, React.createElement("g", undefined, React.createElement("path", {
                              className: "st0",
                              d: "M77.6,11.6c-19.5-17-49-15-66,4.4c-17,19.4-15,49,4.4,66c0.5,0.4,1,0.9,1.6,1.3c0.6,0.5,1.3,1,2,1.5   c2.8,2,5.8,3.7,9,5.1l0.1,0c0.5,0.2,1.1,0.4,1.6,0.7l0.1,0c0.5,0.2,1.1,0.4,1.6,0.6c2.3,0.8,4.7,1.4,7.1,1.8   c5.2,0.9,10.5,0.9,15.7,0c2.4-0.4,4.7-1,7-1.8c0.5-0.2,0.9-0.3,1.4-0.5c0.2-0.1,0.3-0.1,0.5-0.2c0.5-0.2,1.1-0.4,1.6-0.6   c0.1,0,0.1-0.1,0.2-0.1c3.1-1.3,6.1-3,8.8-5c0.6-0.5,1.3-0.9,1.9-1.4c0.5-0.4,1.1-0.9,1.6-1.3c8.4-7.4,13.9-17.5,15.5-28.6l0.5,1.2   l0-7.8C93.6,33.3,87.8,20.4,77.6,11.6z M90.6,46.8c0,12.6-5.5,24.7-15,33c-0.5,0.4-1,0.8-1.5,1.2c-0.6,0.5-1.2,0.9-1.8,1.4   c-2.6,1.9-5.4,3.4-8.3,4.7l-0.1,0c-0.5,0.2-1,0.4-1.5,0.6c-0.1,0-0.2,0.1-0.4,0.2c-0.4,0.2-0.9,0.3-1.3,0.5   c-2.1,0.7-4.3,1.3-6.5,1.7c-4.9,0.8-9.9,0.8-14.7,0c-2.3-0.4-4.5-0.9-6.7-1.7c-0.5-0.2-1-0.3-1.5-0.5l-0.1,0   c-0.5-0.2-1-0.4-1.5-0.6l-0.1,0c-3-1.3-5.8-2.9-8.5-4.8c-0.6-0.5-1.2-0.9-1.8-1.4c-0.5-0.4-1-0.8-1.5-1.2   C-0.3,63.8-2.1,36.1,13.8,17.9C29.7-0.3,57.4-2.1,75.6,13.8c9.4,8.2,14.8,20,15,32.5V46.8z"
                            }), React.createElement("path", {
                              className: "st0",
                              d: "M66.9,25.6h-2.4v-4.1h-4.1v4.1H33.6v-4.1h-4.1v4.1h-2.4c-3.4,0-6.1,2.7-6.1,6.1v35.7c0,3.4,2.7,6.1,6.1,6.1   h39.8c3.4,0,6.1-2.7,6.1-6.1V31.7C73,28.3,70.3,25.6,66.9,25.6z M68.9,67.4c0,1.1-0.9,2-2,2H27.1c-1.1,0-2-0.9-2-2V40.6h43.8V67.4z    M68.9,36.5H25.1v-4.9c0-1.1,0.9-2,2-2h2.4v4.1h4.1v-4.1h26.8v4.1h4.1v-4.1h2.4c1.1,0,2,0.9,2,2V36.5z"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "28.7",
                              y: "44.9"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "36.9",
                              y: "44.9"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "45",
                              y: "44.9"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "53.1",
                              y: "44.9"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "61.2",
                              y: "44.9"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "28.7",
                              y: "53"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "36.9",
                              y: "53"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "45",
                              y: "53"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "53.1",
                              y: "53"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "28.7",
                              y: "61.1"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "36.9",
                              y: "61.1"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "45",
                              y: "61.1"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "53.1",
                              y: "61.1"
                            }), React.createElement("rect", {
                              className: "st0",
                              height: "4.1",
                              width: "4.1",
                              x: "61.2",
                              y: "53"
                            })))
              };
    
  }
}

function CtemIcon(Props) {
  var iconType = Props.iconType;
  var className = Props.className;
  var fill = Props.fill;
  var icon = mapIcon(iconType, fill);
  return React.createElement("span", {
              className: "icon icon-" + (icon.className + (" " + Js_option.getWithDefault("", className)))
            }, icon.content);
}

var make = CtemIcon;

export {
  mapStringToIconType ,
  mapIcon ,
  make ,
  
}
/* react Not a pure module */
